import React, { Component } from 'react'

// lib
import { Row } from 'antd'

// redux
import { connect } from 'react-redux'

// subcomponent
import MediaComponent from './media_component'

class ListMedias extends Component {
    isCanEdit = () => {
        const iscanEdit = this.props.userInfo.actions.find(data => {
            return data === 'MEDIA_EDIT'
        })
        return iscanEdit ? true : false
    }
    isCanDelete = () => {
        const isCanDelete = this.props.userInfo.actions.find(data => {
            return data === 'MEDIA_DELETE'
        })
        console.log('isCanDelete', isCanDelete)
        return isCanDelete ? true : false
    }
    render() {
        console.log('this.props.userinfo', this.props.userInfo)
        let { medias } = this.props

        medias = [...medias]

        return (
            <Row className="ListMedias">
                {medias
                    ? medias.map((media, index) => {
                          return (
                              <MediaComponent
                                  media={media}
                                  key={index}
                                  isCanEdit={this.isCanEdit()}
                                  isCanDelete={this.isCanDelete()}
                              />
                          )
                      })
                    : null}
            </Row>
        )
    }
}

const mapStateToProps = state => {
    return {
        medias: state.qbmedia.medias,
        userInfo: state.auth.userInfo,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListMedias)
